import { memo } from 'react'
import SkeletonLoader from './SkeletonLoader'

/**
 * Skeleton loader for CreativeCard component
 * Matches the exact dimensions and layout of the real CreativeCard
 */
const CreativeCardSkeleton = memo(() => {
  return (
    <div className="tw:relative tw:h-[506px] tw:max-h-[506px] tw:w-[300px] tw:rounded-sm tw:bg-[#17273C] tw:overflow-hidden tw:flex tw:flex-col">
      {/* Selection Checkbox Skeleton */}
      <div className="tw:absolute tw:top-3 tw:left-3 tw:z-10">
        <SkeletonLoader width="20px" height="20px" borderRadius="4px" />
      </div>

      {/* Creative Title Skeleton */}
      <div className="tw:ml-7 tw:p-3 tw:pb-2">
        <SkeletonLoader width="180px" height="16px" borderRadius="4px" />
      </div>

      {/* Ad Preview Skeleton - Large central area */}
      <div className="tw:flex-1 tw:flex tw:justify-center tw:items-start tw:p-4 tw:pt-2">
        <SkeletonLoader 
          width="260px" 
          height="320px" 
          borderRadius="12px" 
        />
      </div>

      {/* Tags Skeleton */}
      <div className="tw:px-3 tw:pt-3 tw:pb-2 tw:flex tw:gap-1.5 tw:items-center">
        <SkeletonLoader width="60px" height="24px" borderRadius="12px" />
        <SkeletonLoader width="80px" height="24px" borderRadius="12px" />
        <SkeletonLoader width="50px" height="24px" borderRadius="12px" />
      </div>

      {/* Status and Actions Skeleton */}
      <div className="tw:px-3 tw:pb-3 tw:flex tw:items-center tw:justify-between">
        <SkeletonLoader width="60px" height="16px" borderRadius="4px" />
        <SkeletonLoader width="24px" height="24px" borderRadius="50%" />
      </div>
    </div>
  )
})

CreativeCardSkeleton.displayName = 'CreativeCardSkeleton'

export default CreativeCardSkeleton